import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
  standalone: false
})
export class BusinessesComponent implements OnInit {
    
    constructor(private http: HttpClient) {
    }

    ngOnInit() {
        document.querySelector("body").classList.remove("opened");
    }

   
}